import { render, staticRenderFns } from "./PageEnablePeriodTracker.vue?vue&type=template&id=74fb3082"
import script from "./PageEnablePeriodTracker.vue?vue&type=script&lang=js"
export * from "./PageEnablePeriodTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports